/// <reference path="logout.js" />
import React, { Component, Fragment } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import { DropdownButton } from 'react-bootstrap';
import Upload from '../images/upload-to-cloud.png';
import UserImg from '../images/icon-userlogin.svg';
import UserMgmtImg from '../images/icon-usermgmt.svg';
import ChangePwdImg from '../images/icon-pwdchange.svg';
import LogoutImg from '../images/icon-logout.svg';
import $ from 'jquery';
import '../FetchData.css';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            userName: null,
            role:null,
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }
    async getUserRole() {
        
        $.ajax({
            url: '/UserManagement/GetUserRoleByEmail',
            headers: { "Authorization": 'Bearer ' + await authService.getAccessToken() },
            type: 'GET',
            async: true,
            data: {
                user: this.state.userName
            },
            success: function (data) {
                this.setState({
                    role: data, loading: true
                });
            }.bind(this)
        });
    }
    async populateState() {
        
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name

        }, () => {
                this.getUserRole();
        });
       
    }
        
    render() {
        const { isAuthenticated, userName, role } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath, role);
        }
    }


    
     
    
    authenticatedView(userName, profilePath, logoutPath, role) {
        if (role === "Admin")
            return (<Fragment>
                <NavLink tag={Link} className="text-light" to="/UploadScans">Upload <img src={Upload} style={{ height: "33px", width: "33px", marginRight: "46px" }} alt="" /> </NavLink>
                <img src={UserImg} alt="" />
                <DropdownButton id="dropdown-basic-button" className="navbar-backgroundcolor" style={{ height: "54px" }} title={userName} >

                    <div className="userDrpdwnMenu"><img src={UserMgmtImg} alt="" /> <NavLink tag={Link} className="text-dark" to="/UserManagement">User Management</NavLink></div>
                    <div className="userDrpdwnMenu"><img src={UserMgmtImg} alt="" /> <NavLink tag={Link} className="text-dark" to="/StudyManagement">Study Management</NavLink></div>
                    <div className="userDrpdwnMenu"><img src={UserMgmtImg} alt="" /> <NavLink tag={Link} className="text-dark" to="/SiteManagement">Site Management</NavLink></div>
                    <div className="userDrpdwnMenu"><img src={ChangePwdImg} alt="" /><NavLink tag={Link} className="text-dark" to={profilePath}>Change Password</NavLink></div>
                    <div className="userDrpdwnMenu"><img src={LogoutImg} alt=""/><NavLink tag={Link} className="text-dark" id="logoutMenuId" to={logoutPath}>Logout</NavLink></div>


                </DropdownButton>

            </Fragment>);
        
        else {
            return (<Fragment> 
                <NavLink tag={Link} className="text-light" to="/UploadScans">Upload <img src={Upload} style={{ height: "33px", width: "33px", marginRight: "46px" }} alt="" /> </NavLink>
                <img src={UserImg} alt=""/>
                <DropdownButton id="dropdown-basic-button" className="navbar-backgroundcolor" style={{ height: "54px" }} title={userName}>                   
                <div className="userDrpdwnMenu"><img src={ChangePwdImg} alt="" /><NavLink tag={Link} className="text-dark" to={profilePath}>Change Password</NavLink></div>
                    <div className="userDrpdwnMenu"><img src={LogoutImg} alt=""/><NavLink tag={Link} className="text-dark" id="logoutMenuId" to={logoutPath}>Logout</NavLink></div> 
                </DropdownButton>

            </Fragment>);
        }

    }

    anonymousView(loginPath) {
        return (<Fragment>
                        <NavItem>
                <NavLink tag={Link} className="text-light" to="/authentication/login">Login</NavLink>
             
            </NavItem>
        </Fragment>);
    }
}